import { ActivityIndicator, ScrollView, StyleSheet, Text, View } from 'react-native'
import React, { useRef, useState } from 'react'
import CustomButton from '../../shared/button/Button'
import Toast from 'react-native-toast-message'
import moment from 'moment'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useInitializeStore } from '../../../stores/initialize'
import { useFormsStore } from '../../../stores/onboarding'
import Card from '../../shared/card/Card'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { globalStyles } from '../../../static/styles/global'
import Canvas from '../../canvas'
import SignatureFormView from '../SignatureFormView'

const OrInformationOnline = ({ navigation, route }) => {
    const {
        values,
        userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
    } = route.params

    const canvasRef = useRef(null)
    const [isDrawing, setIsDrawing] = useState(false)
    const [signatureDataURL, setSignatureDataURL] = useState('')
    const [isSignatureValid, setIsSignatureValid] = useState(false)
    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postoronline, modetailsData } = useFormsStore()
    const [hasDrawn, setHasDrawn] = useState(false);

    const handlesubmit = async (signatureDataURL: string) => {

        const data = {
            entityId: personalstore?.personalData?.entityId,
            essUserKey: intializeStore?.initializeData?.userkey,
            essObKey: essUserOnBoardingKey,
            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
            completeOnline: true,
            reDetermination: values?.redetermination ? values?.redetermination : null,
            filingStatus: values?.filingstatus,
            allowances: values?.allowances ? values?.allowances : null,
            additionalAmount: values?.additionalamount ? values?.additionalamount : null,
            exemptionCode: values?.exemptioncode,
            exempt: values?.exempt,
            sign: signatureDataURL
        }
        const response = await postoronline(data)
        if (response?.success) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        }
        else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        // <>
        //     <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        //         <View style={[globalStyles.horizontalPadGap]}>
        //             <HomeDetailsHeader
        //                 navLabel="Forms"
        //                 navScreen="OnboardingForms"
        //                 title={'OR Withholding Taxation'}
        //             />
        //         </View>
        //     </View>
        //     <ScrollView>
        //         <Card style={{ fontFamily: 'Arial, sans-serif', fontSize: '12px' }}>
        //             <div
        //                 style={{
        //                     display: 'flex',
        //                     justifyContent: 'space-between',
        //                     alignItems: 'flex-start',
        //                     borderBottom: '1px solid #000',
        //                     height: '100%'
        //                 }}
        //             >
        //                 <div style={{ flex: '1' }}>
        //                     <div style={{ fontSize: '24px', fontWeight: 'bold' }}>
        //                         2026 Form OR-W-4
        //                     </div>
        //                     <table>
        //                         <tr>
        //                             <td>
        //                                 <div style={{ fontSize: '10px', marginTop: '3px' }}>
        //                                     Page 1 of 1, 150-101-402 <br />
        //                                     (Rev. 07-28-25, ver. 01)
        //                                 </div>
        //                             </td>
        //                             <td>
        //                                 <div style={{ fontSize: '11px', marginTop: '8px' }}>
        //                                     Oregon Department of Revenue
        //                                 </div>
        //                             </td>
        //                         </tr>
        //                     </table>

        //                     <div
        //                         style={{
        //                             fontSize: '14px',
        //                             fontWeight: 'bold',
        //                             marginTop: '16px'
        //                         }}
        //                     >
        //                         Oregon Withholding Statement and Exemption Certificate
        //                     </div>
        //                 </div>

        //                 <div style={{ flex: '1', textAlign: 'center' }}>
        //                     <div style={{ height: '40px' }}>
        //                         <span
        //                             style={{
        //                                 fontSize: '10px',
        //                                 position: 'relative',
        //                                 top: '12px'
        //                             }}
        //                         >
        //                             <img
        //                                 src="data:image/png;base64,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"
        //                                 alt=""
        //                                 style={{ width: '200px', height: '50px' }}
        //                             />
        //                         </span>
        //                     </div>
        //                 </div>
        //                 <div
        //                     style={{
        //                         width: '132px',
        //                         border: 'none',
        //                         borderLeft: '1px solid #000',
        //                         height: '100%',
        //                         borderRight: '1px solid #000'
        //                     }}
        //                 >
        //                     <div
        //                         style={{
        //                             width: '130px',
        //                             borderBottom: '1px solid #000',
        //                             textAlign: 'center',
        //                             borderTop: '1px solid #000',
        //                             padding: '1px',
        //                             fontSize: '11px'
        //                         }}
        //                     >
        //                         Office use only
        //                     </div>
        //                 </div>
        //             </div>

        //             <div
        //                 style={{
        //                     marginTop: '10px',
        //                     borderTop: '1px solid #000',
        //                     borderBottom: '1px solid #000'
        //                 }}
        //             >
        //                 <table
        //                     style={{
        //                         width: '100%',
        //                         borderCollapse: 'collapse',
        //                         fontSize: '11px'
        //                     }}
        //                 >
        //                     <tr>
        //                         <td
        //                             style={{
        //                                 borderRight: '1px solid #000',
        //                                 borderBottom: '1px solid #000',
        //                                 padding: '3px',
        //                                 width: '30%'
        //                             }}
        //                         >
        //                             First name
        //                             <br />
        //                             {personalstore?.personalData?.firstName}
        //                         </td>
        //                         <td
        //                             style={{
        //                                 borderRight: '1px solid #000',
        //                                 borderBottom: '1px solid #000',
        //                                 padding: '3px',
        //                                 width: '8%'
        //                             }}
        //                         >
        //                             Initial
        //                             <br />
        //                             {personalstore?.personalData?.middleInitial}
        //                         </td>
        //                         <td
        //                             style={{
        //                                 borderRight: '1px solid #000',
        //                                 borderBottom: '1px solid #000',
        //                                 padding: '3px',
        //                                 width: '30%'
        //                             }}
        //                         >
        //                             Last name
        //                             <br />
        //                             {personalstore?.personalData?.lastName}
        //                         </td>
        //                         <td
        //                             style={{
        //                                 borderRight: '1px solid #000',
        //                                 borderBottom: '1px solid #000',
        //                                 padding: '3px',
        //                                 width: '30%'
        //                             }}
        //                         >
        //                             Social Security number (SSN)
        //                             <br />
        //                             {personalstore?.personalData?.ssn}
        //                         </td>
        //                         <td style={{ width: '4%' }}></td>

        //                         <td style={{ padding: '3px', width: '30%', border: 'none' }}>
        //                             <div
        //                                 style={{
        //                                     display: 'flex',
        //                                     alignItems: 'center',
        //                                     gap: '5px',
        //                                     border: 'none'
        //                                 }}
        //                             >
        //                                 <input
        //                                     type="checkbox"
        //                                     style={{ margin: '0' }}
        //                                     readOnly
        //                                     checked={values?.redetermination == 1 ? true : false}
        //                                 />
        //                                 <span>Redetermination</span>
        //                             </div>
        //                         </td>
        //                     </tr>
        //                     <tr>
        //                         <td
        //                             colSpan={3}
        //                             style={{ borderRight: '1px solid #000', padding: '3px' }}
        //                         >
        //                             Address
        //                             <br />
        //                             {personalstore?.personalData?.addressLine1} {personalstore?.personalData?.addressLine2
        //                                 ? `, ${personalstore.personalData.addressLine2}`
        //                                 : ""}
        //                         </td>
        //                         <td style={{ padding: '3px' }}>
        //                             <table
        //                                 style={{ width: '100%', borderCollapse: 'collapse' }}
        //                             >
        //                                 <tr>
        //                                     <td
        //                                         style={{
        //                                             width: '40%',
        //                                             borderRight: '1px solid #000',
        //                                             paddingRight: '2px'
        //                                         }}
        //                                     >
        //                                         City
        //                                         <br />
        //                                         {personalstore?.personalData?.city}
        //                                     </td>
        //                                     <td
        //                                         style={{
        //                                             width: '20%',
        //                                             borderRight: '1px solid #000',
        //                                             padding: '0 2px'
        //                                         }}
        //                                     >
        //                                         State
        //                                         <br />
        //                                         {personalstore?.personalData?.stateValue}
        //                                     </td>
        //                                     <td style={{ width: '40%', paddingLeft: '2px' }}>
        //                                         ZIP code
        //                                         <br />
        //                                         {personalstore?.personalData?.zip}
        //                                     </td>
        //                                 </tr>
        //                             </table>
        //                         </td>
        //                     </tr>
        //                 </table>
        //             </div>

        //             <div
        //                 style={{ marginTop: '8px', fontSize: '10px', lineHeight: '1.4' }}
        //             >
        //                 <b>Note:</b> Your eligibility to claim a certain number of
        //                 allowances or an exemption from withholding may be subject to
        //                 review by the Oregon Department of Revenue. Your employer may be
        //                 required to send a copy of this form to the department for review.
        //             </div>
        //             <div>
        //                 1. <b>Select One</b>
        //                 <input
        //                     type="checkbox"
        //                     readOnly
        //                     checked={values?.filingstatus == 0}
        //                 />{' '}
        //                 Single
        //                 <input
        //                     style={{ marginLeft: '30px' }}
        //                     type="checkbox"
        //                     readOnly
        //                     checked={values?.filingstatus == 1}
        //                 />{' '}
        //                 Married
        //                 <input
        //                     style={{ marginLeft: '30px' }}
        //                     type="checkbox"
        //                     readOnly
        //                     checked={values?.filingstatus == 2}
        //                 />{' '}
        //                 Married, but withhold at the higher single rate.
        //             </div>
        //             <p style={{ marginLeft: '18px' }}>
        //                 <b>Note:</b>Select "Single" if you're married but legally
        //                 separated or your spouse is a non-U.S. citizen without permanent
        //                 resident status.
        //             </p>
        //             <div
        //                 style={{
        //                     marginTop: '8px',
        //                     fontSize: '11px',
        //                     width: '100%',
        //                     display: 'flex'
        //                 }}
        //             >
        //                 <div style={{ width: '80%', lineHeight: '1.3' }}>
        //                     <b>2.</b> <b>Allowances.</b>
        //                     <p>
        //                         Enter the number from Worksheet A, line A5, Worksheet B, line B9, or Worksheet C,
        //                     </p>
        //                     <p style={{ fontSize: '10px', marginLeft: '10px' }}>
        //                         line C6 (see instructions). Otherwise, if you aren’t exempt,
        //                         <b>enter 0</b>................
        //                     </p>
        //                 </div>

        //                 <div style={{ width: '20%', textAlign: 'right' }}>
        //                     2.
        //                     <span
        //                         style={{
        //                             display: 'inline-block',
        //                             width: '100px',
        //                             borderBottom: '1px solid #000',
        //                             fontSize: '11px'
        //                         }}
        //                     >
        //                         {values?.allowances}
        //                     </span>
        //                 </div>
        //             </div>

        //             <div
        //                 style={{
        //                     marginTop: '6px',
        //                     fontSize: '11px',
        //                     width: '100%',
        //                     display: 'flex'
        //                 }}
        //             >
        //                 <div style={{ width: '80%', lineHeight: '1.3' }}>
        //                     <b>3.</b> <b>Additional amount,</b>  from Worksheet C, line C10, or other amount to withhold from each paycheck
        //                     ................................................................
        //                 </div>

        //                 <div style={{ width: '20%', textAlign: 'right' }}>
        //                     3.
        //                     <span
        //                         style={{
        //                             display: 'inline-block',
        //                             width: '100px',
        //                             borderBottom: '1px solid #000'
        //                         }}
        //                     >
        //                         {values?.additionalamount}.00
        //                     </span>
        //                 </div>
        //             </div>

        //             <div
        //                 style={{
        //                     marginTop: '10px',
        //                     fontSize: '11px',
        //                     lineHeight: '1.4',
        //                     width: '80%'
        //                 }}
        //             >
        //                 <p>
        //                     <b>4.</b> <b>Exemption from withholding.</b>I certify my wages
        //                     are exempt from withholding and I meet the conditions for
        //                     exemption as stated on page 2 of the instructions. Complete{' '}
        //                     <b>both</b> lines below:

        //                     I certify my wages are exempt from withholding and I meet the
        //                     conditions for exemption as stated in Form OR-W-4 Instructions. Complete{' '}
        //                     <b>both</b> lines below:
        //                 </p>
        //             </div>
        //             <div
        //                 style={{
        //                     marginTop: '6px',
        //                     fontSize: '11px',
        //                     width: '100%',
        //                     display: 'flex'
        //                 }}
        //             >
        //                 <div style={{ width: '82%', lineHeight: '1.3' }}>
        //                     <span style={{ marginLeft: '20px' }}>
        //                         •  Enter your exemption code from the Exemption chart in Form OR-W-4 Instructions..................................................................
        //                     </span>
        //                 </div>
        //                 <div style={{ width: '22%', textAlign: 'right' }}>
        //                     4a.
        //                     <span
        //                         style={{
        //                             display: 'inline-block',
        //                             width: '90px',
        //                             borderBottom: '1px solid #000',
        //                             marginLeft: '5px'
        //                         }}
        //                     >
        //                         {values?.exemptioncode}
        //                     </span>
        //                 </div>
        //             </div>

        //             <div
        //                 style={{
        //                     marginTop: '6px',
        //                     fontSize: '11px',
        //                     width: '100%',
        //                     display: 'flex'
        //                 }}
        //             >
        //                 <div style={{ width: '82%', lineHeight: '1.3' }}>
        //                     <span style={{ marginLeft: '20px' }}>
        //                         • Write
        //                         “Exempt”..................................................
        //                     </span>
        //                 </div>
        //                 <div style={{ width: '22%', textAlign: 'right' }}>
        //                     4b.
        //                     <span
        //                         style={{
        //                             display: 'inline-block',
        //                             width: '90px',
        //                             borderBottom: '1px solid #000',
        //                             marginLeft: '5px'
        //                         }}
        //                     >
        //                         {values?.exempt}
        //                     </span>
        //                 </div>
        //             </div>

        //             <div style={{ marginTop: '10px', fontSize: '11px' }}>
        //                 <b>Sign here.</b> Under penalty of false swearing, I declare the
        //                 information provided is true, correct, and complete.
        //             </div>

        //             <table style={{ width: '100%' }}>
        //                 <tbody>
        //                     <tr>
        //                         <td
        //                             style={{
        //                                 width: '75%',
        //                                 borderTop: '1px solid #000',
        //                                 fontSize: '12px',
        //                                 borderRight: '1px solid #000',
        //                                 borderBottom: '1px solid #000'
        //                             }}
        //                         >
        //                             Employee signature (This form isn’t valid unless signed.)
        //                             <br />
        //                             <Canvas
        //                                 setSignatureDataURL={setSignatureDataURL}
        //                                 setHasDrawn={setHasDrawn}
        //                                 hasDrawn={hasDrawn}
        //                             />
        //                             <br />
        //                         </td>
        //                         <td
        //                             style={{
        //                                 width: '25%',
        //                                 borderTop: '1px solid #000',
        //                                 fontSize: '12px',
        //                                 borderBottom: '1px solid #000',
        //                                 verticalAlign: 'top'
        //                             }}
        //                         >
        //                             <p style={{}}>
        //                                 <b>{'Date'}</b>
        //                             </p>
        //                             <p>{moment().format('MM/DD/YYYY')}</p>
        //                         </td>
        //                     </tr>
        //                 </tbody>
        //             </table>

        //             <div
        //                 style={{ marginTop: '10px', paddingTop: '5px', fontSize: '11px' }}
        //             >
        //                 <b>Employer use only.</b>
        //                 <table
        //                     style={{
        //                         width: '100%',
        //                         borderCollapse: 'collapse',
        //                         marginTop: '4px'
        //                     }}
        //                 >
        //                     <tr>
        //                         <td
        //                             style={{
        //                                 width: '50%',
        //                                 padding: '3px',
        //                                 borderTop: '1px solid #000',
        //                                 borderBottom: '1px solid #000',
        //                                 borderRight: '1px solid #000'
        //                             }}
        //                         >
        //                             Employer name
        //                             <br />
        //                             <p>{modetailsData?.data?.employersName}</p>
        //                         </td>
        //                         <td
        //                             style={{
        //                                 width: '50%',
        //                                 padding: '3px',
        //                                 borderTop: '1px solid #000',
        //                                 borderBottom: '1px solid #000'
        //                             }}
        //                         >
        //                             Federal employer identification number (FEIN)
        //                             <br />
        //                             <p>{modetailsData?.data?.federalEmployerIDNumber}</p>
        //                         </td>
        //                     </tr>
        //                 </table>
        //                 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        //                     <tr style={{ width: '100%' }}>
        //                         <td
        //                             style={{
        //                                 width: '50%',
        //                                 borderRight: '1px solid #000',
        //                                 borderBottom: '1px solid #000'
        //                             }}
        //                         >
        //                             Employer address
        //                             <br />
        //                             <p>{modetailsData?.data?.employerAddress}</p>
        //                         </td>

        //                         <td
        //                             style={{
        //                                 width: '20%',
        //                                 borderRight: '1px solid #000',
        //                                 borderBottom: '1px solid #000'
        //                             }}
        //                         >
        //                             City
        //                             <br />
        //                             <p>{modetailsData?.data?.city}</p>
        //                         </td>
        //                         <td
        //                             style={{
        //                                 width: '15%',
        //                                 padding: '0 2px',
        //                                 borderRight: '1px solid #000',
        //                                 borderBottom: '1px solid #000'
        //                             }}
        //                         >
        //                             State
        //                             <br />
        //                             <p>{modetailsData?.data?.state}</p>
        //                         </td>
        //                         <td
        //                             style={{
        //                                 width: '15%',
        //                                 paddingLeft: '2px',
        //                                 borderBottom: '1px solid #000'
        //                             }}
        //                         >
        //                             ZIP code
        //                             <br />
        //                             <p>{modetailsData?.data?.zipCode}</p>
        //                         </td>
        //                     </tr>
        //                 </table>
        //                 <h4 style={{ textAlign: 'center' }}>
        //                     —Submit your completed form to your employer—
        //                 </h4>
        //             </div>
        //         </Card>

        //         {loading ? (
        //             <ActivityIndicator />
        //         ) : (
        //             <View
        //                 style={{
        //                     marginTop: 10,
        //                     marginBottom: 25,
        //                     flexDirection: 'row',
        //                     justifyContent: 'space-between'
        //                 }}
        //             >
        //                 <CustomButton
        //                     text={'Previous'}
        //                     color={'warn'}
        //                     onPress={() =>
        //                         navigation.navigate('OrInformationForm', {
        //                             essUserOnBoardingFormKey,
        //                             essUserOnBoardingKey
        //                         })
        //                     }
        //                 />
        //                 <CustomButton
        //                     isDisabled={!signatureDataURL}
        //                     text={'Submit'}
        //                     onPress={handlesubmit}
        //                 />
        //             </View>
        //         )}

        //     </ScrollView>
        // </>

        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'OR Withholding Taxation'}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('OrInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",

                    })
                }
                onSubmit={handlesubmit}
            />

        </>
    )
}

export default OrInformationOnline

const styles = StyleSheet.create({})